import React, { useEffect } from 'react';
import { HereYourPlans } from '@features/onboarding/components/7-finish/HereYourPlans';
import { ExcuseStep } from '@features/onboarding/components/7-finish/components/excuse-step/ExcuseStep';
import { applicationService } from 'src/services/application';
import { useApplicationStore } from 'src/store/application';

export const CoverageReassuranceWithExcuse = () => {
  const { currentApplicationId } = useApplicationStore();

  useEffect(() => {
    console.log('currentApplicationId', currentApplicationId);
    if (currentApplicationId) {
      applicationService.getQuote(currentApplicationId);
    }
  }, [currentApplicationId])
  return (
    <div className="flex flex-col h-full">
      <HereYourPlans />
      <div className="mt-0">
        <ExcuseStep hideTitle={true} />
      </div>
    </div>
  );
}; 